import { AI } from "@/app/constants/apiConstants"
import { aiBaseQuery, apiSlice } from "@/app/redux/apiSlice"
import { FetchBaseQueryError } from "@reduxjs/toolkit/query"

type ExtractedFilter = {
  id: string
  name: string
  type: string
  input_type: "text" | "select" | "multi_select" | "boolean" | "hierarchical"
  is_searchable: boolean
  allows_exclusion: boolean
  supports_value_lookup: boolean
  filter_type: "company" | "contact"
  value: string | number | null
}

type ExtractedFilterGroup = {
  group_id: number
  group_name: string
  group_description: string
  filters: ExtractedFilter[]
}

type ExtractFiltersApiResponse = {
  success: boolean
  data: ExtractedFilterGroup[]
  error_message: string | null
}

export const aiSearchApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    extractFilters: builder.mutation<ExtractedFilterGroup[], { query: string; variables?: Record<string, unknown> }>({
      queryFn: async (body, queryApi, extraOptions) => {
        const result = await aiBaseQuery(
          {
            url: AI.EXTRACT_FILTERS,
            method: "POST",
            body: { query: body.query, variables: body.variables ?? {} }
          },
          queryApi,
          extraOptions
        )

        if ("error" in result && result.error) {
          return { error: result.error }
        }

        const payload = result.data as ExtractFiltersApiResponse
        if (!payload || payload.success === false) {
          return {
            error: {
              status: 400,
              data: (payload && payload.error_message) || "Failed to extract filters"
            } as FetchBaseQueryError
          }
        }

        return { data: payload.data }
      }
    })
  })
})

export const { useExtractFiltersMutation } = aiSearchApiSlice
